
import Loading from 'vux/src/components/loading/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import {login, register, bind} from '@/api/wechat'

export default {
components: {
Loading, Toast, Alert
},
name: "wechat-register",
mounted () {
this.wechatRegister()
},
data () {
return {
show: false,
show1: false,
showError: false
}
},
methods: {
async wechatRegister() {
let code = this.$route.query.code
console.log('register-----')
console.log(this.$route.query.code)
if (code && code !== 'undefined') {
this.show = true
register(code).then(response => {
let uid = response.data;
localStorage.setItem('wechatuid', uid);
console.log('setItem----');
this.show = false;
this.$router.push({path: '/bindUser'});
}).catch(error => {
console.log(error, "loginSub error");
this.show = false
this.show1 = true
});
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/wechat-register.vue